/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4-beta.0.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PerformoTaskFromJSON(json) {
    return PerformoTaskFromJSONTyped(json, false);
}
export function PerformoTaskFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'taskId': !exists(json, 'taskId') ? undefined : json['taskId'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'doneFlag': !exists(json, 'doneFlag') ? undefined : json['doneFlag'],
        'taskTextEntry': !exists(json, 'taskTextEntry') ? undefined : json['taskTextEntry'],
        'taskTextCalc': !exists(json, 'taskTextCalc') ? undefined : json['taskTextCalc'],
        'sortOrder': !exists(json, 'sortOrder') ? undefined : json['sortOrder'],
        'indentLevel': !exists(json, 'indentLevel') ? undefined : json['indentLevel'],
        'boldFlag': !exists(json, 'boldFlag') ? undefined : json['boldFlag'],
        'dataEntry': !exists(json, 'dataEntry') ? undefined : json['dataEntry'],
        'dataFlag': !exists(json, 'dataFlag') ? undefined : json['dataFlag'],
        'meterName': !exists(json, 'meterName') ? undefined : json['meterName'],
        'meterUnits': !exists(json, 'meterUnits') ? undefined : json['meterUnits'],
        'dataPostedFlag': !exists(json, 'dataPostedFlag') ? undefined : json['dataPostedFlag'],
        'readyToPostFlag': !exists(json, 'readyToPostFlag') ? undefined : json['readyToPostFlag'],
    };
}
export function PerformoTaskToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'taskId': value.taskId,
        'workorderId': value.workorderId,
        'assetId': value.assetId,
        'doneFlag': value.doneFlag,
        'taskTextEntry': value.taskTextEntry,
        'taskTextCalc': value.taskTextCalc,
        'sortOrder': value.sortOrder,
        'indentLevel': value.indentLevel,
        'boldFlag': value.boldFlag,
        'dataEntry': value.dataEntry,
        'dataFlag': value.dataFlag,
        'meterName': value.meterName,
        'meterUnits': value.meterUnits,
        'dataPostedFlag': value.dataPostedFlag,
        'readyToPostFlag': value.readyToPostFlag,
    };
}
